import { FeApi } from '../..';
import type { SitePreviewExtended } from '../../domain/entities/site';

import { siteOperationalPhaseMapper } from './site-operational-phase.mapper';

export function sitePreviewExtendedMapper(
  data: FeApi.Site,
): SitePreviewExtended {
  return {
    id: data.accure_id,
    alerts: {
      critical: data.alerts?.critical ?? 0,
      warning: data.alerts?.warning ?? 0,
    },
    cellType: data.cell_type,
    fullFrontendId: data.full_frontend_id,
    lat: data.latitude,
    lng: data.longitude,
    name: data.name,
    nbMissingDocuments: data.missing_docs_count,
    nbOpenTasks: data.open_cards_count,
    nominalEnergyWH: data.nominal_energy_wh ?? undefined,
    nominalPowerW: data.nominal_power_w ?? undefined,
    operationalPhase: siteOperationalPhaseMapper(data.operational_phase),
  };
}
